export default "__VITE_ASSET__BzUYkqYu__"